export default __webpack_public_path__ + "static/media/arrow-down.8cd36b8a.svg";